<template>
  <b-row>
    <b-col>
      <div class="col-md-12" :class="contentClass">
        <verification-user-email
          ref="verificationUserComponent"
          :placement="placement"
          :target="target"
        />
        <b-button
          :id="target"
          class="btn-anchor raised form-submit-btn"
          :class="buttonClass"
          @click="clicked"
        >
          {{ loanAppDoc.approvedCount ? text : nextText }}
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import VerificationUserEmail from '@/components/utils/verification/VerificationUserEmail';


export default {
  components: {
    VerificationUserEmail,
  },
  data() {
    return {
      target: `wizard-button-id-${Math.random()}`,
    };
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    nextText: {
      type: String,
      default: 'Next',
    },
    placement: {
      type: String,
      default: 'leftbottom',
    },
    buttonClass: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: 'text-right',
    },
  },
  computed: {
    loanAppDoc() {
      return this.$store.getters.documents.find(doc => doc.type === 'Loan App') || { approvedCount: 0 };
    },
  },
  methods: {
    clicked() {
      if (this.$refs.verificationUserComponent.isVerified) {
        this.$emit('submit', !this.loanAppDoc.approvedCount);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/form/WizardVerifiedSubmitButton.vue